'use client';

import React from 'react';

const SVGAnimationDemo: React.FC = () => {
  return (
    <div className="p-8 space-y-8">
      <h2 className="text-2xl font-bold text-gray-900 mb-6">SVG Stroke Animation Examples</h2>
      
      {/* Basic stroke animation */}
      <div className="space-y-4">
        <h3 className="text-lg font-semibold">Basic Stroke Animation</h3>
        <svg width="200" height="100" viewBox="0 0 200 100" className="border border-gray-200 rounded">
          <path 
            d="M20 50 Q50 20 80 50 T140 50" 
            stroke="#272D57" 
            strokeWidth="3" 
            fill="none"
            className="svg-stroke-animation stroke-delay-0"
          />
        </svg>
      </div>

      {/* Enhanced stroke animation */}
      <div className="space-y-4">
        <h3 className="text-lg font-semibold">Enhanced Stroke Animation</h3>
        <svg width="200" height="100" viewBox="0 0 200 100" className="border border-gray-200 rounded">
          <path 
            d="M20 50 Q50 20 80 50 T140 50" 
            stroke="#D53333" 
            strokeWidth="3" 
            fill="none"
            className="stroke-animation-enhanced"
          />
        </svg>
      </div>

      {/* Morphing stroke */}
      <div className="space-y-4">
        <h3 className="text-lg font-semibold">Morphing Stroke</h3>
        <svg width="200" height="100" viewBox="0 0 200 100" className="border border-gray-200 rounded">
          <path 
            d="M20 50 Q50 20 80 50 T140 50" 
            stroke="#272D57" 
            strokeWidth="3" 
            fill="none"
            className="stroke-morph"
          />
        </svg>
      </div>

      {/* Glow effect */}
      <div className="space-y-4">
        <h3 className="text-lg font-semibold">Glow Effect</h3>
        <svg width="200" height="100" viewBox="0 0 200 100" className="border border-gray-200 rounded">
          <path 
            d="M20 50 Q50 20 80 50 T140 50" 
            stroke="#D53333" 
            strokeWidth="3" 
            fill="none"
            className="svg-stroke-animation stroke-glow"
          />
        </svg>
      </div>

      {/* Pulse animation */}
      <div className="space-y-4">
        <h3 className="text-lg font-semibold">Pulse Animation</h3>
        <svg width="200" height="100" viewBox="0 0 200 100" className="border border-gray-200 rounded">
          <circle 
            cx="100" 
            cy="50" 
            r="20" 
            stroke="#272D57" 
            strokeWidth="3" 
            fill="none"
            className="stroke-pulse"
          />
        </svg>
      </div>

      {/* Multiple paths with staggered animation */}
      <div className="space-y-4">
        <h3 className="text-lg font-semibold">Staggered Animation</h3>
        <svg width="200" height="100" viewBox="0 0 200 100" className="border border-gray-200 rounded">
          <path 
            d="M20 30 L60 30" 
            stroke="#272D57" 
            strokeWidth="3" 
            fill="none"
            className="svg-stroke-animation stroke-delay-0"
          />
          <path 
            d="M20 50 L60 50" 
            stroke="#D53333" 
            strokeWidth="3" 
            fill="none"
            className="svg-stroke-animation stroke-delay-1"
          />
          <path 
            d="M20 70 L60 70" 
            stroke="#272D57" 
            strokeWidth="3" 
            fill="none"
            className="svg-stroke-animation stroke-delay-2"
          />
        </svg>
      </div>

      {/* Fill animation */}
      <div className="space-y-4">
        <h3 className="text-lg font-semibold">Fill Animation</h3>
        <svg width="200" height="100" viewBox="0 0 200 100" className="border border-gray-200 rounded">
          <rect 
            x="50" 
            y="25" 
            width="100" 
            height="50" 
            fill="#D53333"
            className="fill-animation"
          />
        </svg>
      </div>
    </div>
  );
};

export default SVGAnimationDemo;
